import type { ThemeRegistrationRaw } from 'shiki';

export const dsCodeTheme: ThemeRegistrationRaw = {
  name: 'ds',
  type: 'dark',
  colors: {
    'editor.background': '#00000000',
    'editor.foreground': '#e6e6e6',
  },
  settings: [
    {
      scope: ['comment', 'punctuation.definition.comment'],
      settings: { foreground: '#7d7d7d', fontStyle: 'italic' },
    },
    {
      scope: [
        'keyword',
        'storage',
        'storage.type',
        'keyword.control',
        'keyword.operator.new',
        'keyword.operator.expression',
      ],
      settings: { foreground: '#d63b3b' },
    },
    { scope: ['entity.name.tag'], settings: { foreground: '#d63b3b' } },
    {
      scope: ['string', 'string.quoted', 'string.template'],
      settings: { foreground: '#b0b0b0' },
    },
    {
      scope: [
        'constant.numeric',
        'constant.language',
        'constant.language.boolean',
      ],
      settings: { foreground: '#cfcfcf' },
    },
    {
      scope: ['entity.name.function', 'support.function', 'meta.function-call'],
      settings: { foreground: '#f2f2f2' },
    },
    {
      scope: [
        'entity.name.type',
        'support.type',
        'support.class',
        'entity.name.class',
      ],
      settings: { foreground: '#e6e6e6', fontStyle: 'italic' },
    },
    {
      scope: [
        'variable',
        'variable.other',
        'support.variable',
        'meta.definition.variable',
      ],
      settings: { foreground: '#d8d8d8' },
    },
    { scope: ['variable.parameter'], settings: { foreground: '#c4c4c4' } },
    {
      scope: ['punctuation', 'meta.brace', 'keyword.operator'],
      settings: { foreground: '#909090' },
    },
    {
      scope: ['entity.other.attribute-name'],
      settings: { foreground: '#b0b0b0', fontStyle: 'italic' },
    },
    {
      scope: ['comment.line.number-sign', 'punctuation.definition.tag'],
      settings: { foreground: '#7d7d7d' },
    },
  ],
};
